import React from 'react';
import { motion } from 'framer-motion';

const PrivacyEldritchDescent = () => {
  return (
    <div className="pt-24 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 legal-content">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <span className="text-accent-purple font-semibold tracking-wider text-sm uppercase mb-2 block">App Specific Policy</span>
        <h1>Eldritch Descent X Privacy Policy</h1>
        <p className="text-sm border-l-2 border-accent-purple pl-4 mb-8">
          Last Updated: November 2026
        </p>

        <p>
          This document outlines the privacy practices for <strong>Eldritch Descent X</strong> (including its free
          demo and the earlier Eldritch Descent), published by Eager Dragon Publishing Ltd and developed by
          MediaVerse Labs. It is an addendum to the general MediaVerse Labs Privacy Policy.
        </p>

        <h2>1. No Data Collection by Us</h2>
        <p>
          Eldritch Descent X does not collect, transmit or store any personal information on our servers. We have
          no game servers, no accounts of our own, no advertising and no analytics: the game engine's analytics,
          crash reporting and performance reporting services are switched off. The game plays fully offline.
        </p>

        <h2>2. Local Save Data</h2>
        <p>
          Your progress (scores, unlocks, achievements, lifetime stats, settings and your best-run ghost replays)
          is saved in files in your Windows user folder (AppData\LocalLow\Eager Dragon Publishing\Eldritch Descent X).
          You can delete them at any time; the game then starts fresh.
        </p>

        <h2>3. Store Features (Steam and Epic Games Store)</h2>
        <p>
          When you play through Steam or the Epic Games Store, the game uses that store's own services, signed in
          with the store account you already use:
        </p>
        <ul>
          <li><strong>Achievements and stats:</strong> unlocked achievements and a few lifetime counters (such as
            strata cleared) are sent to your store account so they appear in your profile.</li>
          <li><strong>Leaderboards (Steam):</strong> your best scores are posted to Steam leaderboards together with
            your Steam display name, as Steam shows them to other players.</li>
          <li><strong>Cloud saves (Steam):</strong> if Steam Cloud is on, Steam copies your save files to your
            Steam account so they follow you between PCs.</li>
          <li><strong>Epic Online Services:</strong> on the Epic Games Store the game signs in to Epic Online
            Services with your Epic account to record achievements and stats. Epic gives the game an anonymous
            product user ID for this; we do not receive your email or real name.</li>
        </ul>
        <p>
          This data is held and processed by Valve Corporation and Epic Games, Inc. under their own privacy
          policies. We only see the aggregated, anonymous reports the stores give to publishers (for example how
          many players unlocked an achievement). The Microsoft Store version uses none of these services.
        </p>

        <h2>4. Store Platforms</h2>
        <p>
          The game is distributed through Steam, the Epic Games Store and the Microsoft Store. Each store may
          collect information about purchases, installation, play time and crashes under its own privacy policy.
          The Unity engine may send anonymous, non-identifying hardware information (such as graphics card and
          operating system version) to Unity Technologies when the game first runs.
        </p>

        <h2>5. Links</h2>
        <p>
          The support screens open pages such as the game's store page or our website in your browser or the
          store overlay. Those sites have their own privacy policies.
        </p>

        <h2>6. Children</h2>
        <p>
          We do not knowingly collect personal information from anyone, including children under 13.
        </p>

        <h2>7. Your Rights and Contact</h2>
        <p>
          Because we hold no personal data about you, there is nothing for us to access, correct or delete. For
          data held by a store, use that store's privacy tools. For any privacy question:{' '}
          <a href="mailto:hello@mediaverselabs.com">hello@mediaverselabs.com</a>
        </p>
      </motion.div>
    </div>
  );
};

export default PrivacyEldritchDescent;
